export default __webpack_public_path__ + "src/assets/info.ff287c7687078c4f9eda06f019874c21.svg";